@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper [headerLabel]="('Bulk Update ' + selectedCount + ' Records')"
                  subHeaderLabel="Please enter the values for the fields you want updated. Blank fields will not be updated."
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="!isFormValid || isSaving">
    <div style="overflow-y: auto; max-height: calc(750px - 180px); height: calc(750px - 180px)">
        <form>
            <div class="table-responsive">
                <table class="table table-striped table-condensed table-borderless-body">
                    <tbody>
                        @for (mappedField of mappedFields; track mappedField) {
                            <tr>
                                <td>{{ mappedField.name }}</td>
                                <td>
                                    <import-bulk-update-action [requiredField]="mappedField.isMappingRequired"
                                                               (fieldActionChange)="onActionChanged(mappedField, $event)"
                                                               [changeToAllowed]="isChangeToAllowed(mappedField)"></import-bulk-update-action>
                                </td>
                                <td>
                                    @if (!mappedField.uiCellRenderer) {
                                        <div>
                                            <input [ngModel]="getValue(mappedField.importFileSpecificationFieldId)"
                                                   (ngModelChange)="onValueChanged(mappedField.importFileSpecificationFieldId, $event)"
                                                   type="text" [name]="mappedField.name" class="form-control"
                                                   [disabled]="isDisabled(mappedField.importFileSpecificationFieldId)">
                                        </div>
                                    }
                                    @if (mappedField.uiCellRenderer === 'AssetClassSelector') {
                                        <div>
                                            <asset-class-selector [isRequiredField]="false"
                                                                  (assetClassificationChange)="onAssetClassificationChanged(mappedField.importFileSpecificationFieldId, $event)"
                                                                  [assetClassifications]="mappedField.additionalParams"
                                                                  [isDisabled]="isDisabled(mappedField.importFileSpecificationFieldId)"></asset-class-selector>
                                        </div>
                                    }
                                    @if (mappedField.uiCellRenderer === 'AssessorSelector') {
                                        <div>
                                            <assessor-selector [isRequiredField]="false"
                                                               (assessorChanged)="onAssessorChanged(mappedField.importFileSpecificationFieldId, $event)"
                                                               [assessors]="mappedField.additionalParams"
                                                               [isDisabled]="isDisabled(mappedField.importFileSpecificationFieldId)"></assessor-selector>
                                        </div>
                                    }
                                    @if (mappedField.uiCellRenderer === 'AssessmentClassSelector') {
                                        <div>
                                            <assessment-class-selector (changed)="onAssessmentClassChanged(mappedField.importFileSpecificationFieldId, $event)"
                                                                       [values]="mappedField.additionalParams"
                                                                       [isDisabled]="isDisabled(mappedField.importFileSpecificationFieldId)"></assessment-class-selector>
                                        </div>
                                    }
                                    @if (mappedField.uiCellRenderer === 'GLAccountSelector') {
                                        <div>
                                            <glaccount-selector (changed)="onGLAccountChanged(mappedField.importFileSpecificationFieldId, $event)"
                                                                [values]="mappedField.additionalParams"
                                                                [isDisabled]="isDisabled(mappedField.importFileSpecificationFieldId)"></glaccount-selector>
                                        </div>
                                    }
                                    @if (mappedField.uiCellRenderer === 'TaxingDistrictSelector') {
                                        <div>
                                            <taxing-district-selector (changed)="onTaxingDistrictChanged(mappedField.importFileSpecificationFieldId, $event)"
                                                                      [values]="mappedField.additionalParams"
                                                                      [isDisabled]="isDisabled(mappedField.importFileSpecificationFieldId)"></taxing-district-selector>
                                        </div>
                                    }
                                    @if (mappedField.uiCellRenderer === 'IncomeStatementCategorySelector') {
                                        <div>
                                            <income-statement-category-selector [isRequiredField]="false"
                                                                                (incomeStatementCategoryChange)="onIncomeStatementCategoryChanged(mappedField.importFileSpecificationFieldId, $event)"
                                                                                [incomeStatementCategories]="mappedField.additionalParams"
                                                                                [incomeStatementCategoryName]="getValue(mappedField.importFileSpecificationFieldId)"
                                                                                [isDisabled]="isDisabled(mappedField.importFileSpecificationFieldId)"></income-statement-category-selector>
                                        </div>
                                    }
                                    @if (mappedField.uiCellRenderer === 'GLAccountTypeSelector') {
                                        <div>
                                            <select class="form-select form-select-sm"
                                                    (change)="onGlAccountTypeChanged(mappedField.importFileSpecificationFieldId, $event.target)"
                                                    [disabled]="isDisabled(mappedField.importFileSpecificationFieldId)">
                                                @for (option of mappedField.additionalParams; track option) {
                                                    <option [value]="option.name"
                                                            [selected]="option.name === getValue(mappedField.importFileSpecificationFieldId)">{{ option.name }}
                                                    </option>
                                                }
                                            </select>
                                        </div>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <div>
                @if (validationMessage) {
                    <p class="text-danger">{{ validationMessage }}</p>
                }
            </div>
        </form>
    </div>
</ws-modal-wrapper>
